import _ from 'lodash'
import type {ArrayPropertyTypeMetadata} from '../../../../../metadata'
import type {CssValue} from '../../constants'
import {splitValue} from '../utils/split'

const ITEMS_DELIMITER = ' '

const serialize = (
    val: any,
    {itemsMetadata}: ArrayPropertyTypeMetadata,
    serializeValue: Function
): CssValue | undefined => {
    if (!_.isArray(val)) {
        return undefined
    }

    return val.map(item => serializeValue(item, itemsMetadata.types)).join(ITEMS_DELIMITER)
}

const deserialize = (rule: CssValue, {itemsMetadata}: ArrayPropertyTypeMetadata, deserializeValue: Function): any[] => {
    if (rule === '') {
        return []
    }

    return splitValue(rule, ITEMS_DELIMITER).map(item => deserializeValue(item, itemsMetadata.types))
}

export default {
    serialize,
    deserialize
}
